module.exports = __webpack_public_path__ + "static/media/MozaquaLogo.0b6689fe.svg";